import React from "react";
import Lottie from 'lottie-react'
import "./Token.scss";
import token from '../../assets/token.mp4'
function Token() {
  return (
    <div className="token" id='token'>
      <div className="token_left">
        <video
          src={token}
          width="640"
          height="360"
          controls={false}
          autoPlay
          muted
          loop
          playsInline
          className="aboutUs-lottie"
          preload="auto"
        >
          Your browser does not support the video tag.
        </video>

      </div>
      <div className="token_right">
        <h2>UWPS Token</h2>
        <h4>Innovating a New Financial Paradigm</h4>
        <p>
          Based on ERC-20 and BEP-20 standards, UWPS token is a multi-utility token for transactional activities and full platform access. It adheres to the regulatory guidelines and frameworks laid down by SEC and related authorities. Designed for seamless interoperability and exceptional efficiency, UWPS token facilitates transactions across multiple exchanges and dApps.
        </p>
      </div>
    </div>
  );
}

export default Token;
